export const DEFAULT_DATE_FORMAT = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export const SHORT_DATE_FORMAT = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
};

export const DEFAULT_DATETIME_FORMAT = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const SHORT_DATETIME_FORMAT = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

// выводит локализованную дату
export function formatDate(datestring, format = DEFAULT_DATE_FORMAT) {
  return new Date(datestring).toLocaleDateString('en-GB', format);
}

// выводит локализованную дату и время
export function formatDateTime(datestring, format = DEFAULT_DATETIME_FORMAT) {
  return new Date(datestring).toLocaleDateString('en-GB', format);
}

// вставляет неразрывный пробел после предлога
export function glueUpPrepositions(string) {
  if (string === null) {
    return '';
  }
  return string.replace(/(\s(in|of|the|on|at|and|is|to|if)\s)/g, ' $2\xa0');
}

// сравнивает 2 массива поэлементно
export function isTwoArraysEqual(array1, array2) {
  return (
    array1.length === array2.length &&
    array1.every((value, index) => value === array2[index])
  );
}

// у дат, которые выбираются в календаре без выбора времени ставятся часы 0.
// При перегоне в ISOstring можем получить вчерашнюю дату.
export function removeTimezoneOffset(date) {
  const dateValue = new Date(date);
  return new Date(
    dateValue.getTime() - dateValue.getTimezoneOffset() * 60 * 1000,
  );
}

// асинхронно копирует
export async function requestCopyToClipboard(string) {
  await navigator.clipboard.writeText(string);
}

// проверяем данные из форм перед отправкой на сервер
// если в каком-то поле пустая строка, заменяем ее на null
export function sanitizePostData(formData) {
  const sanitizedData = formData;
  Object.keys(sanitizedData).forEach((key) => {
    sanitizedData[key] = sanitizedData[key] === '' ? null : sanitizedData[key];
  });
  return sanitizedData;
}

export function convertPascalCaseToCamelCase(property) {
  const firstCharacter = property[0];
  return property.replace(firstCharacter, firstCharacter.toLowerCase());
}

export function parseErrorsByFields(errors) {
  const errorsObject = {};
  errors.forEach((error) => {
    const fieldName = convertPascalCaseToCamelCase(error.propertyName);
    errorsObject[fieldName] = error.errorMessages[0];
  });
  return errorsObject;
}

// сравнивает 2 объекта поэлементно
export function isTwoObjectsEqual(object1, object2) {
  const keyArray1 = Object.keys(object1);
  const keyArray2 = Object.keys(object2);

  return (
    keyArray1.length === keyArray2.length &&
    keyArray1.every((key) => object1[key] === object2[key])
  );
}

export function removeArrayElementById(array, elementId) {
  const start = array.slice(0, elementId);
  const end = array.slice(elementId + 1, array.length);

  return [...start, ...end];
}
